export const dialog = {
  namespaced: true,
  state: {
    modalVisible: false,
    modalComponent: null,
    modalWidth: null,
    customClass: null,
  },
  mutations: {
    showModal(state, payload) {
      state.customClass = null;
      state.modalWidth = null;
      if (typeof payload === "object") {
        const { dialogComponentName, dialogWidth, customClass } = payload;
        state.modalComponent = dialogComponentName;
        state.modalWidth = dialogWidth;
        state.customClass = customClass;
      } else {
        state.modalComponent = payload;
      }
      state.modalVisible = true;
    },
    hideModal(state) {
      state.modalVisible = false;
      state.modalWidth = null;
    },
  },
};
